"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var neural_signature_contact_1 = __importDefault(require("./neural-signature-contact"));
var attributes_1 = __importDefault(require("./attributes"));
var message_1 = __importDefault(require("./message"));
var NeuralSignatureExtraction = /** @class */ (function (_super) {
    __extends(NeuralSignatureExtraction, _super);
    function NeuralSignatureExtraction(connection, props) {
        var _this = _super.call(this, connection, props) || this;
        _this.signature = '';
        _this.modelVersion = '';
        _this.initAttributes(props);
        return _this;
    }
    NeuralSignatureExtraction.collectionName = 'signature';
    NeuralSignatureExtraction.attributes = __assign(__assign({}, message_1.default.attributes), { signature: attributes_1.default.String({
            modelKey: 'signature',
        }), modelVersion: attributes_1.default.String({
            modelKey: 'modelVersion',
            jsonKey: 'model_version',
        }), contacts: attributes_1.default.Object({
            modelKey: 'contacts',
            itemClass: neural_signature_contact_1.default,
        }) });
    return NeuralSignatureExtraction;
}(message_1.default));
exports.default = NeuralSignatureExtraction;
